import React from "react";
import { View, StyleSheet } from "react-native";
import NtText from "../../../components/NtText";
import colors from "../../../config/colors";
import NtAboutText from "./NtAboutText";

function NtAboutTextBullet({
  containerStyle,
  number = null,
  style,
  ...otherProbs
}) {
  return (
    <View style={[styles.container, containerStyle]}>
      {!number && (
        <View
          style={{
            width: 8,
            height: 8,
            backgroundColor: "white",
            borderRadius: 10,
            marginTop: 6,
          }}
        />
      )}
      {number && (
        <View>
          <NtAboutText style={[style]} {...otherProbs}>
            {number}
          </NtAboutText>
        </View>
      )}
      <NtAboutText style={[style, { marginLeft: 14 }]} {...otherProbs} />
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flexDirection: "row",
    paddingLeft: 10,
  },
  text: {
    color: "white",
    fontSize: 15,
    fontWeight: "400",
    lineHeight: 22,
  },
});

export default NtAboutTextBullet;
